// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ** Actions
import { login } from "./actions/login.action";

// ############################################################

// Initial state
const initialState = {
	loading: false,
	loaded: false,
	error: false,
	errorMessage: null,
	errorCode: null,
};

// ############################################################

// Slice
const authLoginSlice = createSlice({
	name: "auth/login",
	initialState,
	reducers: {
		loginGoogle: (state) => {
			state.loading = false;
			state.loaded = true;
			state.error = false;
		},
	},
	extraReducers: (builder) => {
		builder
			// Set language
			.addCase(login.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(login.fulfilled, (state) => {
				state.loading = false;
				state.loaded = true;
			})
			.addCase(login.rejected, (state, action) => {
				state.loading = false;
				state.error =
					action.payload || "Wystąpił błąd podczas logowania";
			});
	},
});

// ############################################################

export default authLoginSlice.reducer;

// ** Actions
export const { loginGoogle } = authLoginSlice.actions;

// ############################################################
